import { coreTranslations } from 'translations';

function rootMenu() {
    return {
        i18n: coreTranslations.ng_core_supportAndTraining,
        linkTitle: 'Support & Training',
        icon: 'onsolve-support-icon',
        routeTo: '/support-training',
        isRenderable: true
    };
}

export default rootMenu;
